//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "index",
      head() {
      return {
          htmlAttrs: {
              lang: this.$i18n.locale
          }
      }
  },
  // fontawesome:{
  //   icons: {
  //   solid: ['faAngleRight']}
  // }
}

